<!--
 * @Description: 编辑发票抬头
 * @Author: yeqing
 * @Date: 2021-9-7 17:35:30
 * @LastEditTime:
 * @LastEditors:
-->
<template>
  <a-modal :visible="isVisible" title="编辑发票抬头" @cancel="handleCancel" :confirmLoading="loading" @ok="handleSubmit" ok-text="保存" class="invoice-modal cr-fs-md" width="540px">
    <div class="desc-box cr-text-primary">请您认真核实发票信息，确保信息填写正确。以免影响发票后续使用。</div>
    <a-form-model ref="invoiceForm" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" labelAlign="left" class="cr-mt-2">
      <a-form-model-item label="发票抬头" prop="title">
        <a-input placeholder="请输入" v-model="form.title" />
      </a-form-model-item>
      <a-form-model-item label="纳税号" prop="identifyNo">
        <a-input placeholder="请输入" v-model="form.identifyNo" />
      </a-form-model-item>
      <a-form-model-item label="公司地址">
        <a-input placeholder="请输入公司地址（非必填）" v-model="form.address" />
      </a-form-model-item>
      <a-form-model-item label="备案电话">
        <a-input placeholder="请输入备案电话（非必填）" v-model="form.mobile" />
      </a-form-model-item>
      <a-form-model-item label="开户银行">
        <a-input placeholder="请输入开户银行（非必填）" v-model="form.accountBank" />
      </a-form-model-item>
      <a-form-model-item label="银行账户">
        <a-input placeholder="请输入银行账户（非必填）" v-model="form.accountNo" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { updateInvoiceTotal } from '@/api/billManage'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    invoiceInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        accountBank: '', // 开户银行
        accountNo: '', // 开户账号
        address: '', // 公司地址
        identifyNo: '', // 纳税号
        mobile: '', // 公司电话
        title: '' // 发票抬头
      },
      loading: false,
      rules: {
        title: [{ required: true, message: '请输入发票抬头!' }],
        identifyNo: [{ required: true, message: '请输入纳税号!' }]
      }
    }
  },
  watch: {
    isVisible: {
      handler(item1, item2) {
        if (item1) {
          this.form = { ...this.invoiceInfo }
        }
      }
    }
  },

  methods: {
    // 关闭
    handleCancel() {
      this.$emit('update:isVisible', false)
    },
    // 提交
    handleSubmit() {
      this.$refs.invoiceForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          let res = await updateInvoiceTotal(this.form).catch(() => {
            this.loading = false
          })
          this.loading = false
          if (res.code == 0) {
            this.$message.success('操作成功!')
            this.$emit('update:isVisible', false)
            this.$emit('refresh')
          } else {
            //  this.form = this.invoiceInfo
          }
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.invoice-modal {
  .desc-box {
    line-height: 20px;
    padding: 10px 16px 10px 14px;
    background: @item-selected;
  }
  ::v-deep .ant-form-item {
    margin-bottom: 12px;
  }
  ::v-deep.ant-form-item-label {
    > label::before {
      display: inline-block;
      margin-right: 4px;
      width: 7px;
      content: '';
    }
  }
  ::v-deep.ant-input {
    width: 389px;
  }
  ::v-deep.ant-form-item-required::before {
    content: '*' !important;
    color: @cr-text-red;
  }
}
</style>
